// Phone-sized screens get their own layout (menu behind a button, single column); anything wider keeps the desktop one.
import { useEffect, useState } from '../core/react.js';

export const NARROW = '(max-width: 760px)';
export function useNarrow() {
  const [narrow, setNarrow] = useState(() => window.matchMedia(NARROW).matches);
  useEffect(() => {
    const mq = window.matchMedia(NARROW), on = () => setNarrow(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return narrow;
}
